var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3996 42V8.4C38.3996 7.76348 38.1467 7.15303 37.6967 6.70294C37.2466 6.25286 36.6361 6 35.9996 6H11.9996C11.3631 6 10.7526 6.25286 10.3026 6.70294C9.85247 7.15303 9.59961 7.76348 9.59961 8.4V42L14.3996 37.2L19.1996 42L23.9996 37.2L28.7996 42L33.5996 37.2L38.3996 42Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 14.4H24.0004",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 21.5999H24.0004",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4004 28.8H24.0004",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 13.2001C33.1191 13.2001 33.2351 13.2353 33.3337 13.3013C33.4324 13.3672 33.5093 13.4609 33.5547 13.5705C33.6001 13.6802 33.612 13.8008 33.5889 13.9172C33.5657 14.0336 33.5086 14.1405 33.4247 14.2244C33.3407 14.3083 33.2338 14.3655 33.1174 14.3886C33.0011 14.4118 32.8804 14.3999 32.7708 14.3545C32.6611 14.309 32.5674 14.2321 32.5015 14.1335C32.4356 14.0348 32.4004 13.9188 32.4004 13.8001C32.4004 13.641 32.4636 13.4884 32.5761 13.3759C32.6886 13.2633 32.8413 13.2001 33.0004 13.2001Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 20.5011C33.2351 20.4352 33.1191 20.4 33.0004 20.4C32.8413 20.4 32.6886 20.4632 32.5761 20.5757C32.4636 20.6882 32.4004 20.8408 32.4004 21C32.4004 21.1186 32.4356 21.2346 32.5015 21.3333C32.5674 21.432 32.6611 21.5089 32.7708 21.5543C32.8804 21.5997 33.0011 21.6116 33.1174 21.5884C33.2338 21.5653 33.3407 21.5081 33.4247 21.4242C33.5086 21.3403 33.5657 21.2334 33.5889 21.117C33.612 21.0006 33.6001 20.88 33.5547 20.7704C33.5093 20.6607 33.4324 20.567 33.3337 20.5011Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0004 27.6C33.1191 27.6 33.2351 27.6352 33.3337 27.7012C33.4324 27.7671 33.5093 27.8608 33.5547 27.9704C33.6001 28.0801 33.612 28.2007 33.5889 28.3171C33.5657 28.4335 33.5086 28.5404 33.4247 28.6243C33.3407 28.7082 33.2338 28.7654 33.1174 28.7885C33.0011 28.8117 32.8804 28.7998 32.7708 28.7544C32.6611 28.709 32.5674 28.632 32.5015 28.5334C32.4356 28.4347 32.4004 28.3187 32.4004 28.2C32.4004 28.0409 32.4636 27.8883 32.5761 27.7758C32.6886 27.6633 32.8413 27.6 33.0004 27.6Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipts);
export default __webpack_public_path__ + "static/media/receipts.aa59e77078424b1dcf166f9090b5eee4.svg";
export { ForwardRef as ReactComponent };